export default "__VITE_ASSET__BwQ442yv__"